import { AlertTriangle, ArrowLeft, Home } from "lucide-react"
import { useNavigate } from "react-router-dom";

export const Error404: React.FC = () => {

    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/properties');
    };

    const handleGoBack = () => {
        navigate(-1);
    }; 

    return (
        <div className="container-xxl flex-grow-1 container-p-y marg-bottom-100 ">
            <div className="error-container">
                {/* Animated 404 Number */}
                <div className="error-number-wrapper mt-4">
                    <h1 className="error-number">404</h1>
                    <div className="error-number-shadow">404</div>
                </div>

                {/* Error Icon */}
                <div className="error-icon-wrapper">
                    <div className="error-icon">
                        <AlertTriangle className="error-icon-inner" />
                    </div>
                    <div className="error-icon-ping"></div>
                </div>

                {/* Error Message */}
                <div className="error-message">
                    <h2>Page Not Found</h2>
                    <p className="error-subtitle">
                        Oops! The page you're looking for seems to have vanished into the digital void.
                    </p>
                    <p className="error-description">
                        Don't worry, even the best explorers sometimes take a wrong turn. Let's get you back on track.
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="error-actions">
                    <button onClick={handleGoHome} className="btn-home">
                        <div className="btn-inner">
                            <Home className="btn-icon" />
                            <span>Go Home</span>
                        </div>
                        <div className="btn-overlay"></div>
                    </button>

                    <button onClick={handleGoBack} className="btn-back">
                        <div className="btn-inner">
                            <ArrowLeft className="btn-icon" />
                            <span>Go Back</span>
                        </div>
                    </button>
                </div>

                {/* Decorative Elements */}
                <div className="error-dots">
                    <div className="dot dot-purple"></div>
                    <div className="dot dot-pink"></div>
                    <div className="dot dot-red"></div>
                </div>

                {/* Floating Elements */}
                <div className="float float-1"></div>
                <div className="float float-2"></div>
                <div className="float float-3"></div>
                <div className="float float-4"></div>
            </div>
        </div>
    )
}